import { defaultBaseBackgroundRenderContribution } from "./base-contribution-render";

import { defaultBaseTextureRenderContribution } from "./base-texture-contribution-render";

export const defaultStarTextureRenderContribution = defaultBaseTextureRenderContribution;

export const defaultStarBackgroundRenderContribution = defaultBaseBackgroundRenderContribution;
//# sourceMappingURL=star-contribution-render.js.map
